<template lang="html">
  <b-row>
    <b-col sm="6">
      <b-card>
        <div slot="header">
          <strong>Configurações</strong>
        </div>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Modo recuperação SMS
                  <c-switch class="mx-1" color="primary" checked label variant="3d" v-model="modo"/>
                </b-list-group-item>
              </b-list-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import Input from '../../partial/form/Input.vue'
import Button from '../../partial/button/Button.vue'

export default {
  props: [],
  components: {
    'input-component': Input,
    'button-component': Button,
    cSwitch
  },
  data () {
    return {
      modo: null
    }
  },
  mounted () {
    this.checkRecoveryMode()
  },
  methods: {
    checkRecoveryMode () {
      this.$http.get('api/settings', {params: { key: 'MODO_RECUPERACAO_SMS' }})
        .then(function (res) {
          if (res.data.value === 'true') {
            this.modo = true
          } else {
            this.modo = false
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    changeRecoveryMode () {
      this.$http.post('api/settings', { key: 'MODO_RECUPERACAO_SMS', value: this.modo })
        .then(function (res) {
          console.log('resposta: ' + res.data.status)
          var texto = ''
          if (res.data.status === 'true') {
            texto = 'Modo de recuperação de SMS ativado'
          } else {
            texto = 'Modo de recuperação de SMS desativado'
          }
          this.$bvToast.toast(texto, {
            title: 'Modo de recuperação de SMS',
            autoHideDelay: 5000,
            variant: 'primary'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao alterar o modo de recuperação',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    }
  },
  watch: {
    'modo' (valor, valorAntigo) {
      if (valorAntigo !== null) {
        this.changeRecoveryMode()
      }
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/validations/SmsRecovery.vue